function Index() {
  return (
    <div className="text-center px-6 py-6 lg:px-10 bg-gradient-to-br from-[#1E1E1E] to-[#000000]">
      <div className="grid gap-4 lg:gap-10">
        {/* Bottom Section */}
        <div className="flex flex-col lg:flex-row justify-between">
          <div className="flex flex-col gap-4 lg:gap-10">
            <p className="font-inter text-white font-bold lg:font-extrabold text-[17px] lg:text-4xl text-left">
              Have questions or need assistance?
              <br />
              Reach out to us!
            </p>
            <p className="font-inter text-white text-xs text-left">
              Copyright © 2025 Whitelion Systems Private Limited. All rights
              reserved
            </p>
          </div>
          <div className="flex justify-center items-end">
            <p className="font-inter text-white text-sm">
              Version: {process.env.REACT_APP_WEBSITE_VERSION}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Index;
